import { CountriesRepository } from '../../../domains/locations/Countries/CountriesRepository.js';
import { PostalCodesRepository } from '../../../domains/locations/PostalCodes/PostalCodesRepository.js';
import { PostalZonesRepository } from '../../../domains/locations/PostalZones/PostalZonesRepository.js';

class Locations {
  /** @deprecated import CountriesRepository instead */

  /** @deprecated import PostalCodesRepository instead */

  /** @deprecated import PostalZonesRepository instead */

  constructor(apiClient) {
    this.apiClient = apiClient;
    this.countries = new CountriesRepository(apiClient);
    this.postalCodes = new PostalCodesRepository(apiClient);
    this.postalZones = new PostalZonesRepository(apiClient);
  }
}

export { Locations };
//# sourceMappingURL=Locations.js.map
